import { createRouter, createWebHistory } from "vue-router";

const pcRoutes = [
    {
        path: "/", // 路由路径
        name: "pc-layout", // 路由名称
        component: () => import("@/layouts/PCLayout.vue"),
        meta: { title: '首页' },
        children: [
            {
                path: '', // 默认子路由
                name: 'pc-home',
                component: () => import("@/views/pc/HomePage.vue"),

            },
            {
                path: "/login",
                name: "login",
                component: () => import("@/views/pc/LoginPage.vue"),
                meta: { title: '登录' },
            },
            {
                path: "/qa",
                component: () => import("@/views/pc/QAPage.vue"),
                meta: { title: '使用答疑' },
                children: [
                    {
                        path: "/tutorial",
                        name: "tutorial",
                        component: () => import("@/views/pc/TutorialPage.vue"),
                        meta: { title: '七步教程' },
                    },
                ]
            },
        ]
    },

];
const mobileRoutes = [
    {
        path: "/m/", // 路由路径
        name: "mobile-layout", // 路由名称
        component: () => import("@/layouts/MobileLayout.vue"),
        meta: { title: '首页' },
        children: [
            {
                path: '', // 
                name: 'mobile-home',
                component: () => import("@/views/mobile/HomePage.vue"),
            },
            {
                path: 'start',
                name: 'mobile-tutorial',
                component: () => import("@/views/mobile/TutorialPage.vue"),
                meta: { title: '七步教程' },
            },
            {
                path: 'mobile-more',
                name: 'mobile-more',
                component: () => import("@/views/mobile/DetailPage.vue"),
                meta: { title: '详细' },
            },
        ]
    },
];
const redirectRoutes = [
    {
        path: "/m/download/app/memobus/:pathMatch(.*)*",
        redirect: "/"
    }
];
const router = createRouter({
    history: createWebHistory(),
    routes: [...pcRoutes, ...mobileRoutes, ...redirectRoutes], // 路由配置简写形式，同 routes: routes
});



router.beforeEach((to, from, next) => {
    document.title = to.meta.title + " - 图公主" || '默认标题'; // 使用路由元信息中的title或者默认标题
    // 获取设备类型（考虑用户偏好）
    // 2. 获取设备类型（考虑用户偏好）
    const deviceType = getDevicePreference()

    // 3. 当前路径是否匹配设备类型
    const isMobilePath = to.path.startsWith('/m')
    const shouldBeMobile = deviceType === 'mobile'

    // 重定向逻辑
    if (shouldBeMobile && !isMobilePath) {
        const mobilePath = `/m${to.path === '/' ? '' : to.path}`
        return next(mobilePath)
    }

    if (!shouldBeMobile && isMobilePath) {
        const pcPath = to.path.replace('/m', '') || '/'
        return next(pcPath)
    }

    next();
});

function getDevicePreference() {
    // 1. 检查本地存储的用户偏好
    const userPreference = localStorage.getItem('devicePreference')
    if (userPreference) return userPreference

    // 2. 根据UA检测设备
    const isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )

    return isMobile ? 'mobile' : 'pc'
}

export default router;